import "./TermsAndConditions.css";
import Background from "./Background";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import { useState } from "react";

function TermsAndConditions() {
  const [language, setLanguage] = useState("en");

  return (
    <>
      <Background />
      <Footer />
      <div
        style={{
          position: "absolute",
          backgroundColor: "rgba(0,0,0,0.5)",
          height: "40px",
          width: "80px",
          right: "80px",
          top: "50px",
          display: "flex",
          justifyContent: "space-evenly",
          alignItems: "center",
        }}
      >
        <span
          className="terms-and-conditions-language-button"
          style={{
            color: "white",
            textShadow: "0px 0px 5px purple",
            fontSize: "22px",
            zIndex: "100",
          }}
          onClick={() => setLanguage("en")}
        >
          EN
        </span>
        <div style={{ border: "1px solid white", height: "80%" }}></div>
        <span
          className="terms-and-conditions-language-button"
          style={{
            color: "white",
            textShadow: "0px 0px 5px purple",
            fontSize: "22px",
            zIndex: "100",
          }}
          onClick={() => setLanguage("de")}
        >
          DE
        </span>
      </div>
      <div className="terms-and-conditions">
        {language != "en" ? (
          <div className="content">
            <h1>Allgemeine Geschäftsbedingungen (AGB)</h1>{" "}
            <h2>1) Allgemeine Hinweise</h2>
            <p>
              <b>1.1</b> Diese Allgemeinen Geschäftsbedingungen (AGB) regeln die
              Nutzung der von GliaTech (im Folgenden „Anbieter“) angebotenen
              Software und Dienstleistungen über die Webseite
              https://gliatech.net/ durch Verbraucher (im Folgenden „Nutzer“).
            </p>{" "}
            <p>
              <b>1.2</b> Abweichende Bedingungen des Nutzers werden nicht
              anerkannt, es sei denn, der Anbieter stimmt ihrer Geltung
              ausdrücklich schriftlich zu.
            </p>{" "}
            <h2>2) Leistungsbeschreibung</h2>{" "}
            <p>
              <b>2.1</b> Der Anbieter stellt die Nutzung folgender Software zur
              Verfügung: KI-gesteuerte, textbasierte Abenteuer + die
              anschließende Erstellung eines Buchs zum jeweiligen Abenteuer. (im
              Folgenden „Dienst“, hauptsächlich auf das Spielen eines Abenteuers
              bezogen).
            </p>
            <p>
              <b> 2.2</b> Der Dienst kann ausschließlich von Nutzern mit einem
              gültigen zeitbasierten Nutzungszugang verwendet werden. Nutzer
              können durch den Erwerb von Paketen ihre Nutzungszeit verlängern.
              Zusätzlich können separat ,,Tokens'' für die Erstellung von
              Büchern gekauft werden. Die Nutzung dieser ,,Tokens'' erfolgt
              außerhalb des zeitbasierten Nutzungszugang (auch nach Ablauf des
              Nutzungszeitraums können diese genutzt werden)
            </p>{" "}
            <p>
              <b>2.3 </b> Die Verfügbarkeit des Dienstes kann durch
              Wartungsarbeiten oder unvorhersehbare Ereignisse (z. B. technische
              Probleme) eingeschränkt sein. Der Anbieter bemüht sich, Ausfälle
              auf ein Minimum zu reduzieren.{" "}
            </p>{" "}
            <h2>3) Vertragsschluss</h2>{" "}
            <p>
              <b>3.1 </b> Der Vertrag zwischen dem Nutzer und dem Anbieter kommt
              zustande, wenn der Nutzer ein zeitbegrenztes Nutzungspaket über
              die Webseite bestellt und der Anbieter die Bestellung bestätigt.
            </p>{" "}
            <p>
              <b>3.2</b> Die Darstellung der Nutzungspakete auf der Webseite
              stellt kein rechtlich bindendes Angebot dar, sondern eine
              Einladung zur Abgabe eines Angebots durch den Nutzer.
            </p>{" "}
            <h2>4) Preise und Zahlung </h2>{" "}
            <p>
              <b>4.1</b> Die Preise für die Nutzungspakete sind auf der Webseite
              angegeben und enthalten die gesetzliche Mehrwertsteuer.
            </p>{" "}
            <p>
              <b>4.2</b> Die Zahlung erfolgt über die auf der Webseite
              angebotenen Zahlungsmethoden. Der Zugang wird nach erfolgreicher
              Zahlung aktiviert.
            </p>{" "}
            <p>
              <b>4.3</b> Der Nutzer ist verpflichtet, korrekte
              Zahlungsinformationen anzugeben. Im Falle von Rücklastschriften
              trägt der Nutzer die dadurch entstehenden Kosten, sofern er diese
              zu vertreten hat.
            </p>{" "}
            <h2>5) Widerrufsrecht</h2>{" "}
            <p>
              <b>5.1</b> Nutzer haben das gesetzliche Widerrufsrecht von 14
              Tagen ab Kaufdatum, sofern die Nutzung des Dienstes noch nicht
              begonnen hat. Durch den Kauf eines Pakets erklären sich die Nutzer
              damit einverstanden, dass das Widerrufsrecht erlischt, sobald die
              Nutzung aktiv begonnen wurde.
            </p>{" "}
            <h2>6) Nutzungsrechte</h2>{" "}
            <p>
              <b>6.1</b> Der Nutzer erhält ein einfaches, nicht übertragbares
              Nutzungsrecht zur Verwendung der Software während der Laufzeit
              seines Nutzungspakets.
            </p>{" "}
            <p>
              <b>6.2</b> Es ist dem Nutzer untersagt, die Software oder Teile
              davon zu vervielfältigen, zu bearbeiten, weiterzuveräußern oder
              Dritten zugänglich zu machen.
            </p>{" "}
            <h2>7) Haftung und Gewährleistung</h2>{" "}
            <p>
              <b>7.1</b>
              Gliatech übernimmt keine Haftung für die ununterbrochene
              Verfügbarkeit des Dienstes.
            </p>{" "}
            <p>
              <b>7.2</b> Technische Störungen werden nach bestem Wissen und
              Gewissen behoben.
            </p>{" "}
            <p>
              <b>7.3</b>Die Haftung für Schäden, die durch einfache
              Fahrlässigkeit verursacht wurden, ist ausgeschlossen, soweit keine
              wesentlichen Vertragspflichten verletzt wurden.
            </p>
            <p>
              <b>7.4</b> Eine weitergehende Haftung des Anbieters ist
              ausgeschlossen.
            </p>{" "}
            <h2>8) Datenschutz</h2>{" "}
            <p>
              Die Erhebung, Verarbeitung und Nutzung personenbezogener Daten
              erfolgt gemäß der{" "}
              <Link to={"/privacyPolicy"}>Datenschutzerklärung</Link>.
            </p>{" "}
            <h2>9) Vertragsbeendigung</h2>{" "}
            <p>
              <b>9.1</b> Der Vertrag endet automatisch, wenn das erworbene
              Nutzungspaket abläuft und nicht verlängert wird.
            </p>{" "}
            <p>
              <b>9.2</b> Der Anbieter behält sich das Recht vor, das Konto eines
              Nutzers bei Verstößen gegen diese AGB zu sperren oder zu kündigen.
            </p>{" "}
            <h2>10) Änderungen der AGB</h2>{" "}
            <p>
              <b>10.1</b> Der Anbieter behält sich das Recht vor, diese AGB zu
              ändern. Änderungen werden dem Nutzer mindestens vier Wochen vor
              Inkrafttreten in Textform mitgeteilt.
            </p>{" "}
            <p>
              <b>10.2</b> Widerspricht der Nutzer den Änderungen nicht innerhalb
              von vier Wochen, gelten diese als akzeptiert.
            </p>{" "}
            <h2>11) Anwendbares Recht und Gerichtsstand</h2>{" "}
            <p>
              <b>11.1</b> Es gilt das Recht der Bundesrepublik Deutschland unter
              Ausschluss des UN-Kaufrechts.
            </p>{" "}
            <p>
              <b>11.2</b> Für Verbraucher gilt der gesetzliche Gerichtsstand.
              Für Unternehmen ist der Gerichtsstand der Sitz des Anbieters.
            </p>
            <div style={{ height: "5%" }}></div>
          </div>
        ) : (
          <div className="content">
            <h1>Terms and Conditions (T&Cs)</h1>
            <h2>1) General Information</h2>
            <p>
              <b>1.1</b> These Terms and Conditions (T&Cs) govern the use of the
              software and services offered by GliaTech (hereinafter referred to
              as the "Provider") through the website https://gliatech.net/ by
              consumers (hereinafter referred to as the "User").
            </p>
            <p>
              <b>1.2</b> Deviating conditions from the user will not be accepted
              unless the provider expressly agrees to them in writing.
            </p>
            <h2>2) Description of Services</h2>
            <p>
              <b>2.1</b> The provider offers the use of the following software:
              AI-powered, text-based adventures + the subsequent creation of a
              book for each respective adventure. (hereinafter referred to as
              the "Service," mainly concerning the playing of an adventure).
            </p>
            <p>
              <b>2.2</b> The service can only be used by users with a valid
              time-based access. Users can extend their usage time by purchasing
              packages. Additionally, "Tokens" for the creation of books can be
              purchased separately. The use of these "Tokens" occurs outside the
              time-based access (even after the usage period has expired, they
              can still be used).
            </p>
            <p>
              <b>2.3</b> The availability of the service may be limited due to
              maintenance work or unforeseen events (e.g., technical problems).
              The provider strives to minimize downtime.
            </p>
            <h2>3) Conclusion of Contract</h2>
            <p>
              <b>3.1</b> The contract between the user and the provider is
              concluded when the user orders a time-limited usage package via
              the website and the provider confirms the order.
            </p>
            <p>
              <b>3.2</b> The presentation of the usage packages on the website
              is not a legally binding offer but an invitation for the user to
              make an offer.
            </p>
            <h2>4) Prices and Payment</h2>
            <p>
              <b>4.1</b> The prices for the usage packages are listed on the
              website and include the statutory value-added tax.
            </p>
            <p>
              <b>4.2</b> Payment is made via the payment methods offered on the
              website. Access will be activated after successful payment.
            </p>
            <p>
              <b>4.3</b> The user is obliged to provide correct payment
              information. In the case of chargebacks, the user bears the costs
              arising from them, unless they are not responsible for the
              chargebacks.
            </p>
            <h2>5) Right of Withdrawal</h2>
            <p>
              <b>5.1</b> Users have the statutory right of withdrawal for 14
              days from the date of purchase, provided the use of the service
              has not yet started. By purchasing a package, users agree that the
              right of withdrawal expires once the service has been actively
              used.
            </p>
            <h2>6) Usage Rights</h2>
            <p>
              <b>6.1</b> The user receives a simple, non-transferable right to
              use the software for the duration of their usage package.
            </p>
            <p>
              <b>6.2</b> The user is prohibited from copying, modifying,
              reselling, or making the software or parts of it accessible to
              third parties.
            </p>
            <h2>7) Liability and Warranty</h2>
            <p>
              <b>7.1</b> GliaTech is not liable for the uninterrupted
              availability of the service.
            </p>
            <p>
              <b>7.2</b> Technical issues will be resolved to the best of the
              provider’s knowledge and ability.
            </p>
            <p>
              <b>7.3</b> Liability for damages caused by simple negligence is
              excluded unless essential contractual obligations have been
              violated.
            </p>
            <p>
              <b>7.4</b> Any further liability of the provider is excluded.
            </p>
            <h2>8) Data Protection</h2>
            <p>
              The collection, processing, and use of personal data is carried
              out in accordance with the{" "}
              <Link to={"/privacyPolicy"}>Privacy Policy</Link>.
            </p>
            <h2>9) Termination of Contract</h2>
            <p>
              <b>9.1</b> The contract automatically ends when the purchased
              usage package expires and is not renewed.
            </p>
            <p>
              <b>9.2</b> The provider reserves the right to suspend or terminate
              a user’s account in case of violations of these T&Cs.
            </p>
            <h2>10) Changes to the T&Cs</h2>
            <p>
              <b>10.1</b> The provider reserves the right to modify these T&Cs.
              Changes will be communicated to the user at least four weeks
              before taking effect, in writing.
            </p>
            <p>
              <b>10.2</b> If the user does not object to the changes within four
              weeks, the changes are deemed accepted.
            </p>
            <h2>11) Applicable Law and Jurisdiction</h2>
            <p>
              <b>11.1</b> The law of the Federal Republic of Germany applies,
              excluding the UN Convention on Contracts for the International
              Sale of Goods.
            </p>
            <p>
              <b>11.2</b> For consumers, the statutory place of jurisdiction
              applies. For businesses, the place of jurisdiction is the
              provider's registered office.
            </p>
            <div style={{ height: "5%" }}></div>
          </div>
        )}
      </div>
    </>
  );
}

export default TermsAndConditions;
